import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { widgetPreviewViews } from '../constants'
import WidgetPreview from '../WidgetPreview/WidgetPreview'
import * as Styles from './styles'

const CheckoutPreview = ({ appearance }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.Card>
        <WidgetPreview view={widgetPreviewViews.checkout} appearance={appearance} />
      </Styles.Card>
      <Text type="bodySRegular" color={theme.colors.text.muted}>
        {t('Vista previa ilustrativa. El aspecto final de los botones del checkout sigue el tema de cada tienda.')}
      </Text>
    </Styles.Container>
  )
}

export default CheckoutPreview
